import { render, staticRenderFns } from "./AnxTableCol.vue?vue&type=template&id=28ec5454&scoped=true&"
import script from "./AnxTableCol.vue?vue&type=script&lang=ts&"
export * from "./AnxTableCol.vue?vue&type=script&lang=ts&"
import style0 from "./AnxTableCol.vue?vue&type=style&index=0&id=28ec5454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec5454",
  null
  
)

export default component.exports